import { useQuery } from '@apollo/client';
import { Grid, Stack } from '@mui/material';
import { DEFAULT_CURRENCY } from '@procureai/schemas';
import { CurrencyProvider } from '@procureai/ui-mui';

import { useNegotiationDetail } from '../Module.hooks';

import { AgreementStatus } from './components/AgreementStatus';
import { CancelledStatus } from './components/CancelledStatus';
import { ManualReviewStatus } from './components/ManualReviewStatus';
import { NoAgreementReachedStatus } from './components/NoAgreementReachedStatus';
import { NEGOTIATION_CASE_DETAIL_STATUS_WIDGET_QUOTE_QUERY } from './NegotiationCaseDetailStatusWidget.query.gql';
import { combinedStatus } from './NegotiationCaseDetailStatusWidget.types';

export const NegotiationCaseDetailStatusWidget = () => {
  const { negotiationId } = useNegotiationDetail();

  const variables = {
    id: negotiationId,
  };

  const { data } = useQuery(NEGOTIATION_CASE_DETAIL_STATUS_WIDGET_QUOTE_QUERY, {
    variables,
    skip: !negotiationId,
  });
  const negotiationCaseStatus = data?.tesseract.negotiationCase.status;
  const isMasked = data?.tesseract.negotiationCase.isMaskedBidding;
  const negotiatedQuote = data?.tesseract.negotiationCase.negotiatedQuote;
  const supplierInteractionMode = data?.tesseract.negotiationCase.options?.supplierInteractionMode;
  const cancellationReason = data?.tesseract.negotiationCase.cancellationReason;
  const cancellationReasonText = data?.tesseract.negotiationCase.cancellationReasonText;

  return negotiationCaseStatus && combinedStatus.includes(negotiationCaseStatus) && negotiatedQuote ? (
    <Grid container size={12}>
      <CurrencyProvider value={negotiatedQuote?.currency || DEFAULT_CURRENCY}>
        <Stack spacing={4} sx={{ flexGrow: 1 }}>
          <AgreementStatus
            isMasked={isMasked}
            negotiationCaseStatus={negotiationCaseStatus}
            negotiatedQuote={negotiatedQuote}
          />
          <ManualReviewStatus negotiationCaseStatus={negotiationCaseStatus} negotiatedQuote={negotiatedQuote} />
          <NoAgreementReachedStatus
            negotiationCaseStatus={negotiationCaseStatus}
            negotiatedQuote={negotiatedQuote}
            supplierInteractionMode={supplierInteractionMode}
          />
          <CancelledStatus
            negotiationCaseStatus={negotiationCaseStatus}
            negotiatedQuote={negotiatedQuote}
            supplierInteractionMode={supplierInteractionMode}
            cancellationReason={cancellationReason}
            cancellationReasonText={cancellationReasonText}
          />
        </Stack>
      </CurrencyProvider>
    </Grid>
  ) : null;
};
